import React from 'react';
import { Flex } from '..';

export interface ReusableStaticImageProps {
    image: any;
    padding?: string;
    margin?: string;
    style?: any;
    width?: number;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    ref?: any;
    id?: string;
}

export const ReusableStaticImage = (props: ReusableStaticImageProps) => {
    const { image, width, padding, margin, style, onClick = () => { }, ref, id } = props;

    return (
        <Flex
            className={style && style}
            ref={ref}
            id={id}
            onClick={onClick}
            style={{ display: 'flex', padding: padding && `${padding}`, margin: margin && `${margin}`, boxSizing: 'border-box' }}
        >
            <img
                draggable="false"
                style={{ width: width ? `${width}rem` : '40px' }}
                alt='empty'
                src={image}
            />
        </Flex>
    );
};
